module.exports = __webpack_public_path__ + "img/index-ship01.ecb58673.png";